import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { createOutgoingQuoteLineItem } from "app/modules/OutgoingQuotes/actions";
import {
  Modal as BootstrapModal,
  Header,
  Close
} from "app/modules/shared/components/Modal/index";
import { STANDARD } from "MODULES/OutgoingQuotes/constants";
import Form from "./Form";

function Modal({ open, close, onSubmit, quote }) {
  const initialValues = {
    quote_type: STANDARD,
    inventory_ids: [],
    faa: true,
    easa: true
  };

  return (
    <BootstrapModal open={open} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Add a Part</h4>
      </Header>
      <Form
        close={close}
        initialValues={initialValues}
        onSubmit={onSubmit}
        quote={quote}
      />
    </BootstrapModal>
  );
}

export default connect(undefined, dispatch => ({
  onSubmit: data => dispatch(createOutgoingQuoteLineItem(data))
}))(Modal);

Modal.propTypes = {
  close: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  quote: PropTypes.instanceOf(Map)
};



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/Detail/LineItems/Create/Modal.jsx